import { useSetRecoilState } from "recoil"
import layoutStates from "../../recoil/atoms/layout"

/** Hook that control the overlay visibility */
const useOverlayControl = () => {
  const setOverlayDisplayAllowed = useSetRecoilState(
    layoutStates.overlayDisplayAllowed
  )
  const setTargetTabIndex = useSetRecoilState(
    layoutStates.historyTabEnabledMobile
  )

  const hideAllOverlays = () => {
    // Logic to hide all overlays
    setOverlayDisplayAllowed(false)

    // deselect active tab
    setTargetTabIndex(-1)
  }

  const allowAllOverlays = () => {
    // Logic to allow all overlays to be displayed again
    setOverlayDisplayAllowed(true)
  }

  return { hideAllOverlays, allowAllOverlays }
}

export default useOverlayControl
